import Badge from '@splunk/react-ui/Badge';
import Button from '@splunk/react-ui/Button';
import Card from '@splunk/react-ui/Card';
import Heading from '@splunk/react-ui/Heading';
import { variables } from '@splunk/themes';
import styled from 'styled-components';
import { ThemeProvider, useLegacyThemeServiceKey } from '../../../common/theme/ThemeProvider';
import { ModernDashboardsCardImage } from './ModernDashboardsCardImage';

export default function ModernDashboardsCard(): JSX.Element {
    const themeKey = useLegacyThemeServiceKey();

    return (
        <ThemeProvider colorScheme={themeKey}>
            <StyledCard>
                <Card.Body>
                    <StyledContent>
                        <StyledImage src={ModernDashboardsCardImage} />
                        <StyledMessage>
                            <StyledHeading level={2}>
                                Introducing the new dashboard experience{' '}
                                <StyledBadge
                                    backgroundColor={variables.notificationColorInfoWeak}
                                    label="New"
                                />
                            </StyledHeading>
                            <StyledMessageContent>
                                The new dashboards offer flexible layouts, more visualization types,
                                and broader data source support to help you visualize key metrics
                                across your organization.
                            </StyledMessageContent>
                            <div>
                                <Button appearance="primary" to={'#/modern-dashboards/'}>
                                    <StyledViewDashboardsText>
                                        View new dashboards
                                    </StyledViewDashboardsText>
                                </Button>
                            </div>
                        </StyledMessage>
                    </StyledContent>
                </Card.Body>
            </StyledCard>
        </ThemeProvider>
    );
}

const StyledCard = styled(Card)`
    margin-inline: ${variables.spacingLarge};
`;

const StyledContent = styled.div`
    display: flex;
    gap: ${variables.spacingXXLarge};
`;

const StyledImage = styled.img`
    width: 350px;
    height: 222px;
`;

const StyledMessage = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${variables.spacingSmall};
`;

// Override bootstrap styles.
const StyledHeading = styled(Heading)`
    align-items: center;
    display: flex;
    margin: 0 !important;
    line-height: ${variables.lineHeightSingle} !important;
    font-size: ${variables.fontSizeXXLarge} !important;
    font-weight: ${variables.fontWeightBold} !important;
`;

const StyledBadge = styled(Badge)`
    flex: 0 0 auto;
    margin-inline: ${variables.spacingSmall};
`;

const StyledMessageContent = styled.div`
    flex: 1;
`;

// Required since signalview breaks primary button text color in dark mode.
const StyledViewDashboardsText = styled.span`
    color: ${variables.contentColorInverted};
`;
